import { Snackbar } from "@mui/material";
import { useMemo } from "react";
import { ErrorCode, FileRejection } from "react-dropzone";
import { collectFileRejectionErrors } from "src/components/inputs/file-upload/fileUploadUtils";

export interface InvalidFilesErrorMessages {
    [ErrorCode.FileInvalidType]: string;
    [ErrorCode.FileTooLarge]: string;
    [ErrorCode.FileTooSmall]: string;
    [ErrorCode.TooManyFiles]: string;
    unknown: string;
}

export const useErrorMessage = (errorCodes: ErrorCode[], errorMessages: InvalidFilesErrorMessages) => {
    if (errorCodes.length < 1) {
        return errorMessages.unknown;
    }

    // invalid file type has the highest importance amongst errors
    if (errorCodes.includes(ErrorCode.FileInvalidType)) {
        return errorMessages[ErrorCode.FileInvalidType];
    }

    return errorMessages[errorCodes[0]];
};

export const InvalidFilesSnackbar = ({
    rejectedFiles,
    clearRejectedFiles,
    errorMessages,
}: {
    rejectedFiles: FileRejection[];
    clearRejectedFiles: () => void;
    errorMessages: InvalidFilesErrorMessages;
}) => {
    const errorCodes = useMemo(() => collectFileRejectionErrors(rejectedFiles), [rejectedFiles]);
    const errorMessage = useErrorMessage(errorCodes, errorMessages);

    if (rejectedFiles.length < 1) return null;

    return (
        <Snackbar
            data-testid="file-upload-error-snackbar"
            ContentProps={{
                sx: {
                    backgroundColor: "error.dark",
                },
            }}
            open={rejectedFiles.length > 0}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            autoHideDuration={6000}
            onClose={clearRejectedFiles}
            message={errorMessage}
        />
    );
};
